


















































































































import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import postAppMessage, { MessageHandlers } from '@/utils/poster'
import { HeaderMap } from '@/constants/figurePainting'
import { FigurePaintingForm } from '@/interfaces/figurePainting'

export default Vue.extend({
  name: 'FigurePaintingSummary',
  created () {
    postAppMessage(MessageHandlers.UPDATE_HEADER, HeaderMap.SUMMARY)
  },
  computed: {
    form (): FigurePaintingForm {
      return this.$store.state.figurePainting.form
    },
    agreeToShare: {
      get (): boolean {
        return this.form.agreeToShare
      },
      set (value: boolean) {
        this.handleFormUpdate({
          value,
          target: 'agreeToShare'
        })
      }
    },
    ...mapGetters('figurePainting', [
      'total',
      'preview',
      'hasFrame',
      'bodyLabel',
      'frameLabel',
      'frameSizeLabel',
      'pricePerPeople',
      'priceByFrame'
    ])
  },
  methods: {
    ...mapActions('figurePainting', [
      'handleFormUpdate'
    ]),
    handleNextStep () {
      const { $route: { query } } = this
      this.$router.push({ path: 'image', query })
    }
  }
})
